import {Stack} from "@mui/material";
import React from "react";

import NotificationsSettings from "../notifications/NotificationsSettings";
import SentNotificationsWidget from "../notifications/SentNotificationsWidget";

function NotificationsPage(props: {
	course: {id: number; name: string};
	viewOnly?: boolean;
}) {
	return (
		<Stack spacing={3}>
			<NotificationsSettings course={props.course} viewOnly={props.viewOnly} />

			<SentNotificationsWidget courseId={props.course.id} />
		</Stack>
	);
}

export default NotificationsPage;
